import styled from 'styled-components'

const Container = styled.div`
  padding: 16px;
  border-radius: 8px 8px 0px 0px;
  box-sizing: border-box;
  margin: 16px 24px;
  background: #fdfdfd;
  z-index: 1;
  @media (max-width: 900px) {
    padding: 0.5rem;
    margin: 16px 8px;
  }
`

const BackButtonContainer = styled.div`
  display: none;

  @media (max-width: 600px) {
    padding: auto 16px;
    display: block;
  }
`

const Title = styled.h2`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #3e445e;
  padding: 0px 12px 8px 0px;
  @media (max-width: 600px) {
    padding: 16px;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    padding: 8px 8px 16px 10px;
  }
`

const ThumbnailImageListContainer = styled.div`
  background: var(--Dove);
  display: flex;
  flex-wrap: wrap;
  overflow-y: ${({ isScroll }) => (isScroll ? '' : 'scroll')};
  max-height: ${({ isScroll }) => (isScroll ? 'fit-content' : '430px')};
  height: fit-content;
  width: ${({ isScroll }) => (isScroll ? '100%' : '35%')};
  &:first-child {
    margin-bottom: 100px;
  }
  @media (max-width: 900px) {
    width: 100%;
  }
`
const ThumbnailImageContainer = styled.div`
  padding: 12px 12px;
  cursor: pointer;
  background: ${({ active }) => (active ? '#ebe4ddf2' : '#FFF')};
  width: ${({ isScroll }) => (isScroll ? '33%' : '100%')};
  display: ${({ isScroll }) => (isScroll ? 'block' : 'flex')};
  /* justify-content: ${({ isScroll }) =>
    isScroll ? 'space-between' : 'space-between'}; */
  justify-content: start;
  position: relative;
  @media (max-width: 600px) {
    width: 100%;
    padding: 12px 0px;
    display: block;
  }
`
const LectureText = styled.div`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  display: inline-block;
  color: rgba(13, 21, 54, 0.4);
`
const LectureTitle = styled.div`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(13, 21, 54, 0.8);
`
const ThumbnailImage = styled.img`
  width: ${({ isScroll }) => (isScroll ? '100%' : 'auto')};
  height: ${({ isScroll }) => (isScroll ? 'auto' : '100px')};
  margin-right: 12px;
  border-radius: 4px;
  display: inline-block;
  @media (max-width: 900px) {
    min-width: ${({ isScroll }) => (isScroll ? '100%' : 'auto')};
    height: ${({ isScroll }) => (isScroll ? '176px' : '100px')};
  }
  @media (max-width: 600px) {
    width: 100%;
    margin: 0px auto;
    height: 200px;
  }
`

const CoursesContainer = styled.div`
  width: 100%;
  display: flex;
  margin: '24px 0px';
  padding-top: 16px;
  overflow-x: scroll;
  @media (max-width: 600px) {
    margin: 0px;
    padding-top: 0px;
    display: ${({ isActiveLesson }) => (isActiveLesson ? 'flex' : 'none')};
  }
`
const CourseCard = styled.div`
  min-width: 240px;
  max-width: 300px;

  background: ${({ active }) => (active ? '#068ae2' : '#F0F1F5')};
  border-radius: 4px;
  cursor: pointer;
  padding: 12px 12px;
  margin: 0px 24px 12px 0px;

  h3 {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${({ active }) =>
      active ? 'var(--Dove)' : 'rgba(13, 21, 54, 0.4)'};
  }
  p {
    font-family: 'Noto Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    color: ${({ active }) =>
      active ? 'var(--Dove)' : 'rgba(13, 21, 54, 0.4)'};
  }
  @media (max-width: 600px) {
    border-radius: 0px;
    margin: 6px 12px 6px 0px;

    h3 {
      font-size: 12px;
      line-height: 16px;
    }
    p {
      font-size: 14px;
      line-height: 20px;
    }
  }
`
const CourseName = styled.h3``
const CourseText = styled.p``

const VedioContainer = styled.div`
  width: 60%;
  @media (max-width: 900px) {
    margin-left: 0px;
    width: 100%;
  }
`
const LessonVedio = styled.video`
  max-height: 320px;
  @media (max-width: 900px) {
    max-height: auto;
  }
`
const LessonTitle = styled.h3`
  font-family: 'Noto Sans';
  font-style: normal;
  color: rgba(13, 21, 54, 0.8);
  padding: 8px 0px 4px 0px;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
`
const LessonDescription = styled.div`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(13, 21, 54, 0.65);
  padding-top: 8px;
  padding-bottom: 8px;
  border-top: 1px solid rgba(13, 21, 54, 0.2);
  border-bottom: 1px solid rgba(13, 21, 54, 0.2);
  margin-top: 8px;
  @media (max-width: 900px) {
    border-top: none;
    margin-top: 0px;
    border-bottom: none;
  }
`
const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const IconContainer = styled.div`
  display: flex;
  /* padding: 6px; */
  align-items: center;
  /* cursor: pointer; */
`
const CommentsInfo = styled.div`
  font-family: 'Roboto';
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: rgba(13, 21, 54, 0.8);
`
const LikesAndShareInfo = styled.div`
  font-family: 'Roboto';
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: rgba(13, 21, 54, 0.8);
  padding-left: 8px;
`
const ViewsWrapper = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(13, 21, 54, 0.4);
  padding: 0px;
`
const CourseVedioSection = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  @media (max-width: 900px) {
    flex-direction: column;
  }
`
const BlueText = styled.span`
  color: var(--Azure500);
  font-weight: 600;
  cursor: pointer;
  font-size: 12px;
`

const AddCommentIconContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 8px 16px 16px 0px;
  margin-bottom: 0px;
  min-width: 104px;
  @media (min-width: 600px) {
    display: none;
  }
`
const SharesIconContainer = styled(AddCommentIconContainer)``

const IconText = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: rgba(13, 21, 54, 0.65);
  margin-top: 12px;
`
const IconTextDesktop = styled(IconText)`
  margin: auto 8px;
  font-size: 14px;
  margin-top: 0px;
`
const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  transition: all 0.5s ease;
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  svg {
    transition: all 0.5s ease;
    display: none;
  }
  &:hover {
    display: block;
    background: rgba(0, 0, 0, 0.4);
    svg {
      position: absolute;
      top: 33%;
      left: ${({ isScroll }) => (isScroll ? '45%' : '25%')};
      display: block;
    }
  }
`

const TopSignUpSection = styled.div`
  height: 56px;
  display: flex;
  align-items: center;
  padding: 16px 52px;
  border-bottom: 1px solid #E0E2EB;
  justify-content: space-between;

  @media (max-width: 600px ){
    padding: 16px 24px;
  }
  img {
    height: 26px;
  }
`


export {
  Container,
  Title,
  BackButtonContainer,
  ThumbnailImageListContainer,
  ThumbnailImageContainer,
  LectureTitle,
  LectureText,
  ThumbnailImage,
  CourseCard,
  CourseName,
  CourseText,
  CoursesContainer,
  VedioContainer,
  LessonVedio,
  LessonTitle,
  LessonDescription,
  FlexContainer,
  IconContainer,
  CommentsInfo,
  CourseVedioSection,
  BlueText,
  ViewsWrapper,
  LikesAndShareInfo,
  AddCommentIconContainer,
  SharesIconContainer,
  IconText,
  IconTextDesktop,
  Overlay,
  TopSignUpSection
}
